export enum NewsKind {
	Article = "Article",
	OneTimeArticle = "OneTimeArticle",
	Comparison = "Comparison",
	CaseStudy = "CaseStudy",
}
